import { asyncLoad } from '@util'

export default {
  path: 'buy',
  component: asyncLoad(() => import('@components/LocalMerchant/VR/Buy'))
}
